

















import { computed, defineComponent, ref } from "@vue/composition-api";
import FileInputVue from "../FileInput.vue";
import autocompleteVue from "./autocomplete.vue";
import listaVue from "./lista.vue";

export default defineComponent({
  props: {
    value: null,
    campo: Object,
    modelo: Object
  },
  components: {
    Autocomplete: autocompleteVue,
    FileInput: FileInputVue,
    lista: listaVue
  },
  setup(props, { emit }) {

    const campoRef = ref()

    const actualizar = (valor) => {
      emit("input", valor);
    };

    const desenfocar = () => {
      console.warn("desenfocar por implementar")
      campoRef.value.desenfocar()
    }

    const mostrar = computed(() => {
      const { campo, modelo } = props
      const { mostrar, oculto } = campo
      
      return mostrar ? modelo[mostrar] : !oculto
    })

    return {
      actualizar,
      desenfocar,
      mostrar,
      campoRef
    };
  },
});
